import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, CLEAR_AUTH_ERROR, AUTH_INITIALIZED } from '../action/types';

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  error: null,
  loading: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isInitialized: true,
        user: action.payload,
        error: null,
        loading: false
      };
    
    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isInitialized: true,
        user: null,
        error: action.payload,
        loading: false
      };
    
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        isInitialized: true,
        user: null,
        error: null,
        loading: false
      };
    
    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        error: null
      };
    
    case AUTH_INITIALIZED:
      return {
        ...state,
        isInitialized: true
      };
    
    default:
      return state;
  }
};

export default authReducer; 